/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Csjensblank_Electrical_Engineering32Inputs */

const en__field_enum_csjensblank_electrical_engineering32 = /** @type {(inputs: _Field_Enum_Csjensblank_Electrical_Engineering32Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Electrical Engineering`)
};

const de__field_enum_csjensblank_electrical_engineering32 = /** @type {(inputs: _Field_Enum_Csjensblank_Electrical_Engineering32Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elektrotechnik`)
};

/**
* | output |
* | --- |
* | "Electrical Engineering" |
*
* @param {_Field_Enum_Csjensblank_Electrical_Engineering32Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_csjensblank_electrical_engineering32 = /** @type {((inputs?: _Field_Enum_Csjensblank_Electrical_Engineering32Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Csjensblank_Electrical_Engineering32Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_csjensblank_electrical_engineering32(inputs)
	return de__field_enum_csjensblank_electrical_engineering32(inputs)
});
export { _field_enum_csjensblank_electrical_engineering32 as "_field_enum_CSJENSBLANK_ELECTRICAL_ENGINEERING" }